// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/frontend/stylesheets/pagination.sass
// module id = 217
// module chunks = 0